export default "__VITE_ASSET__nrxFN$pa__"